// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"355":"6957ae6c","954":"e733282b"}[chunkId] + ".chunk.js");